import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme } from './globalStyles';

import AppSubscribe from './components/AppSubscribe';
import ErrorBoundary from './components/ErrorBoundary';

const ELEMENT_ID = 'piano-widget';

function showOffer(title, subtitle) {
  const goToURLParams = {
    returnTo: window.location.href,
  };
  ReactDOM.render(
    <React.StrictMode>
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <AppSubscribe
            message1={title}
            message2={subtitle}
            brief={true}
            goToURLParams={goToURLParams}
          />
        </ErrorBoundary>
      </ThemeProvider>
    </React.StrictMode>,
    document.getElementById(ELEMENT_ID),
  );
}

window.showOffer = showOffer;
